"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns `undefined`
 *
 * @example
 * ```ts
 * noop() // undefined
 * ```
 */
// eslint-disable-next-line @typescript-eslint/no-empty-function
function noop() { }
exports.default = noop;
//# sourceMappingURL=noop.js.map